module.exports = __webpack_public_path__ + "static/img/leaf1@3x.df6982f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dominos-assets/leaf1@3x.png
// module id = USnz
// module chunks = 0